import { BotIcon } from 'lucide-react'
import { memo, type ReactNode } from 'react'

import badgeStatic from '@/assets/logo/badge-static.svg'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { getInitials } from '@/lib/initials.util'

import type { Notification } from './notification.interface'

export interface NotificationAvatarProps {
  notification: Notification
}

const NotificationAvatarBase: React.FC<NotificationAvatarProps> = ({ notification }): ReactNode => {
  if (notification.type === 'system_balance_low') {
    return (
      <Avatar className="notification-avatar size-9">
        <AvatarImage src={badgeStatic} alt="System" className="brightness-0 dark:invert p-1" />
        <AvatarFallback className="bg-muted text-muted-foreground text-xs">SYS</AvatarFallback>
      </Avatar>
    )
  }

  if (notification.type === 'agent_reply') {
    return (
      <Avatar className="notification-avatar size-9">
        {notification.agentAvatarUrl && (
          <AvatarImage src={notification.agentAvatarUrl} alt={notification.agentName} />
        )}
        <AvatarFallback className="bg-primary text-primary-foreground">
          <BotIcon className="size-4" />
        </AvatarFallback>
      </Avatar>
    )
  }

  const userName = notification.userName
  const avatarUrl = notification.userAvatarUrl

  return (
    <Avatar className="notification-avatar size-9">
      {avatarUrl && <AvatarImage src={avatarUrl} alt={userName} />}
      <AvatarFallback className="text-xs">{getInitials(userName)}</AvatarFallback>
    </Avatar>
  )
}

export const NotificationAvatar = memo(NotificationAvatarBase)

NotificationAvatar.displayName = 'NotificationAvatar'
